import '.ay{flex-shrink:0;}.ssr-plugin'
import '.w{padding:1rem;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.bq{height:100%;}.ssr-plugin'
import '.be{border:none;}.ssr-plugin'
import '.bf{background-color:transparent;}.ssr-plugin'
import '.e4{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.dt{position:sticky;}.ssr-plugin'
import '.e5{top:4rem;}.ssr-plugin'
import '.e6{z-index:7;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.e7{padding-bottom:1rem;}.ssr-plugin'
import '.y{margin-bottom:1rem;}.ssr-plugin'
import '.e8{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.du{top:0px;}.ssr-plugin'
import '.bo{left:0px;}.ssr-plugin'
import '.bp{right:0px;}.ssr-plugin'
import '.e9{bottom:0px;}.ssr-plugin'
import '.ea{z-index:9999;}.ssr-plugin'
import '.eb{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d5{justify-content:flex-end;}.ssr-plugin'
import '.ch{flex:1;}.ssr-plugin'
import '.au{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ay w a8 bq be bf e4"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ae"
    >
      <div className="dt e5 e6 ah e7 y e8 a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a2 du bo bp e9 ea ah eb a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="w a d5 e8"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ch au">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
